import { CruiseGroupCode } from "@silversea-ssc/web-cruise-groups";
import {
  AvailableConfigs,
  InfographicConfig,
  infographicConifg
} from "@silversea-ssc/ui-components-react";

export const infographicConfigForCruiseGroup = (
  cruiseGroup: CruiseGroupCode | undefined
): InfographicConfig => {
  const config: AvailableConfigs =
    cruiseGroup == "AntarcticaBridge" ? "antarcticaBridge" : "default";
  return infographicConifg(config);
};
